module.exports = __webpack_public_path__ + "static/media/image1.09626c9b.png";